import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '../Avatar';

function ContactRow({ contact, onClick }) {
  const isPerson = contact.type === 'person';
  
  // Subtitle Logic: Job Title, Organization, or Email
  const getSubtitle = () => {
    if (isPerson) {
      if (contact.jobTitle && contact.relatedAccountName) {
        return `${contact.jobTitle} at ${contact.relatedAccountName}`;
      } else if (contact.jobTitle) {
        return contact.jobTitle;
      } else if (contact.relatedAccountName) {
        return contact.relatedAccountName;
      }
    }
    
    // Fallback to email if available
    if (contact.emailAddresses && contact.emailAddresses.length > 0) {
        return contact.emailAddresses[0];
    }
    
    return '';
  };

  return (
    <div 
      onClick={() => onClick(contact)}
      className="flex items-center p-3 bg-white border-b border-gray-100 hover:bg-gray-50 cursor-pointer transition-colors"
    >
      {/* Column 1: Avatar */}
      <div className="mr-4">
        <Avatar 
          name={contact.name} 
          surname={contact.surname} 
          imageURL={contact.imageURL} 
          type={contact.type}
          size="md"
        />
      </div>

      {/* Column 2 & 3: Name & Info */}
      <div className="flex-1 min-w-0">
        <h3 className="text-base md:text-sm font-semibold text-gray-900 truncate">
          {contact.name} {isPerson && contact.surname ? contact.surname : ''}
        </h3>
        {getSubtitle() && (
          <p className="text-sm md:text-xs text-gray-500 truncate">
            {getSubtitle()}
          </p>
        )}
      </div>

      {/* Column 4: Count Badge (Right) */}
      <div className="ml-4 flex-shrink-0">
        {contact.notesCreated > 0 && (
          <span className="inline-flex items-center justify-center px-2.5 py-0.5 rounded-full text-sm md:text-xs font-medium bg-gray-100 text-gray-600">
            {contact.notesCreated}
          </span>
        )}
      </div>
    </div>
  );
}

ContactRow.propTypes = {
  contact: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
};

export default ContactRow;

